<template>
  <b-row>
    <b-col :cols="wide ? null : 6">
      <div>
        <slot name="search"></slot>
      </div>
    </b-col>
    <b-col :cols="wide ? 'auto' : 6">
      <div class="d-flex search-actions">
        <div class="pt-1">
          <slot name="filteredItems"></slot>
        </div>
        <div class="ml-3">
          <slot name="filtersButton"></slot>
        </div>
        <div>
          <slot name="resetButton"></slot>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    // The search slot takes all the room left by the actions, instead of half the row.
    wide: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style>
.search-actions {
  padding-top: 1.6rem;
}
</style>
